import '@/common';
import { createSliderWidget } from '@/widgets/SliderWidget';
import { createScrollToHandler } from '@/utils/scrollto';
import {createDropDownBlockWidget} from '@/widgets/DropDownBlockWidget';
import {createAboutWidget} from "@/widgets/AboutWidget";
import { JSONParser } from '@/utils/JSONParser';
import { feedbackWidget} from '@/common/widgets';
import { ModalData } from '@/widgets/FeedbackWidget/types';
import { AboutWidgetData } from '@/widgets/AboutWidget/types';

const configurable = process.env.NODE_ENV === 'development';

export const aboutWidget = createAboutWidget(
    document.querySelector('#about-widget')!
);


const dropDownBlockWidget = document.querySelector('#drop-down-block-widget');
if(dropDownBlockWidget) { createDropDownBlockWidget(dropDownBlockWidget!); }

const sliderEl = document.querySelector('#slider-widget')
if(sliderEl) {
    createSliderWidget(sliderEl);
}

[...document.querySelectorAll('a.js-scroll-to-id')].forEach((element) => {
    createScrollToHandler(element);
});

const mortgagePlanCards = [...document.querySelectorAll('.mortgage-plan')];
const priceOutput = document.querySelector('.passport-svg-price__price');
//const priceOldOutput = document.querySelector('.passport-svg-price__price-old');
const priceOutputMobile = document.querySelector('.m-passport-price-bar__price');

function setInnerHTML(el: Element | null, value: string) {
    if (el) {
        el.innerHTML = value;
    } else {
        console.log('Cant find element');
    }
}

mortgagePlanCards.forEach((card) => {
    card.addEventListener('click', () => {
        for (const item of mortgagePlanCards) {
            if (item === card) {
                const price = item.getAttribute('data-mortgage-plan-price');

                if (price) {
                    setInnerHTML(priceOutputMobile, price);
                    setInnerHTML(priceOutput, price);
                    item.classList.add('active');
                }
            } else {
                item.classList.remove('active');
            }
        }
    });
});

const finishingInfoHead = document.querySelector('.finishing-info__head');
if(finishingInfoHead) {
    finishingInfoHead.addEventListener('click', () => {
        // @ts-ignore
        finishingInfoHead.parentNode.parentNode.parentNode.classList.toggle("active");
    });
}

[...document.querySelectorAll('.js-feedback-widget')].forEach((el) => {
    el.addEventListener('click', () => {
        const parser = new JSONParser('js-feedback-widget-parser');
        const action = el.getAttribute('data-action');
        const rawModalData = parser.parse<ModalData>(el.getAttribute('data-modal'));

        switch (action) {
            default:

                const mortgagePlanId =
                    document
                        .querySelector('.mortgage-plan.active')
                        ?.getAttribute('data-mortgage-plan-id') || '-1';

                const trailer = Object.assign({}, rawModalData.trailer, {
                    mortgagePlanId,
                });

                const modalData = Object.assign({}, rawModalData, {
                    trailer,
                });

                feedbackWidget.show(modalData);
                break;
        }
    });
});

Object.defineProperties(window, {
    $aboutWidget: {
        value: Object.freeze({
            show(aboutWidgetData?: AboutWidgetData) {
                //if(aboutWidget) { aboutWidget.show(aboutWidgetData); }
            },
            hide() {
                if(aboutWidget) {
                    aboutWidget.close();
                }
            },
        }),
        configurable,
    }
});

[...document.querySelectorAll('.p-about-card')].forEach((el) => {
    el.addEventListener('click', () => {
        if( window.innerWidth < 960 ) {
            const parser = new JSONParser('js-about-widget-parser');
            const jsAboutWidget = el.querySelector('.js-about-widget');
            if (jsAboutWidget) {
                const rawAboutData = parser.parse<AboutWidgetData>(jsAboutWidget.getAttribute('data-about'));
                const aboutData = Object.assign({}, rawAboutData);
                if(aboutWidget) {
                    aboutWidget.show(aboutData);
                }
            }
        }

    });
});
